import React from 'react';
import get from 'lodash/get';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useApp } from 'Shared/utils/hooks/use-app';

// Helpers
import { validEmail } from 'Shared/helpers';

// Components
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpButton } from 'Wpds/components/button';
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import { VisuallyHidden } from 'Wpds/components/visually-hidden/VisuallyHidden';

// Styles
import './UserConfirmation.scss';

const UserConfirmation = () => {
  const {
    app: {
      routes: { userConfirmationPath },
    },
  } = useApp();

  const [isSubmitting, toggleIsSubmitting] = useToggle(false);

  const handleSubmit = () => toggleIsSubmitting();

  const baseClassName = 'UserConfirmation';
  return (
    <div className={baseClassName}>
      <h3 className={`${baseClassName}__title`}>Resend Confirmation</h3>
      <p>Enter your work email address below and we&apos;ll resend the account confirmation email.</p>
      <WpForm method="post" action={userConfirmationPath} onSubmit={handleSubmit}>
        <VisuallyHidden>
          <WpTextField
            type="text"
            id="authenticity_token"
            label="authenticity_token"
            value={get(document.getElementsByName('csrf-token')[0], 'content')}
            readOnly
          />
        </VisuallyHidden>
        <WpFormLayout>
          <WpTextField
            name="email"
            id="user[email]"
            type="text"
            label="Work email"
            placeholder=""
            required
            disabled={isSubmitting}
            validate={{
              isEmail: {
                callback: validEmail,
                error: 'Please enter a valid email.',
              },
            }}
            showRequiredIndicator={false}
            autoFocus
          />
        </WpFormLayout>
        <WpButton size="lg" btnType="submit" block loading={isSubmitting}>
          Resend
        </WpButton>
      </WpForm>
      <div className={`${baseClassName}__footer`}>
        <p className={`${baseClassName}__footer__signup-link`}>
          New User?{' '}
          <a href={PageUrls.ONBOARDING_WIZARD} rel="noopener noreferrer">
            Sign up
          </a>
        </p>
        <p className={`${baseClassName}__footer__sign-in`}>
          <a href={PageUrls.LOGIN_PAGE} rel="noopener noreferrer">
            Back to Sign In
          </a>
        </p>
      </div>
    </div>
  );
};

export default UserConfirmation;
